import { FC } from 'react';
import { Resident } from '@/types/resident';
import { ProfileCircle } from './profile-circle';
import { Button } from '../ui/button';

export type ResidentRowProps = {
  actionText: string;
  resident: Resident;
  onActionClick: (resident: Resident) => void;
};

export const ResidentRow: FC<ResidentRowProps> = ({
  actionText,
  resident,
  onActionClick,
}) => (
  <div className="flex flex-row items-center py-5">
    <ProfileCircle size="md" />
    <div className="ml-4 flex flex-col gap-1">
      <div className="text-sm/6 font-semibold">{resident.name}</div>
      <div className="text-sm">{resident.identifier}</div>
    </div>
    <div className="grow"></div>
    <Button onClick={() => onActionClick(resident)} variant="tertiary">
      {actionText}
    </Button>
  </div>
);
